import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useEmpresa } from "../../context/EmpresaContext";
import { getEmpresaBrand, loginScannerUsuario } from "../../services/sininApi";
import sininLogo from "../../assets/sinin-logo.svg";

const SININ_DARK = "#05080a";
const SININ_TURQ = "#25f4df";

export default function ScannerLogin() {
  const { empresaId } = useParams();
  const empresaSlug = String(empresaId || "").trim().toUpperCase();
  const navigate = useNavigate();
  const { setEmpresa } = useEmpresa();
  const [dni, setDni] = useState("");
  const [password, setPassword] = useState("");
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");
  const [empresaConfig, setEmpresaConfig] = useState(null);

  useEffect(() => {
    if (!empresaSlug) return;
    getEmpresaBrand(empresaSlug.toLowerCase())
      .then(res => setEmpresaConfig(res?.empresa || null))
      .catch(() => setEmpresaConfig(null));
  }, [empresaSlug]);

  const ingresar = async () => {
    setError("");
    if (!empresaSlug || !dni || !password) return setError("Completá DNI y contraseña.");
    setSending(true);
    try {
      const res = await loginScannerUsuario(empresaSlug, dni.trim(), password);
      if (res?.error) setError(res.error);
      else {
        localStorage.setItem("sinin_token", res.token || "");
        setEmpresa({
          ...res,
          empresaId: res.empresaId,
          membresias: res.membresias || [],
          logoUrl: empresaConfig?.logoUrl || res.logoUrl || "",
        });
        navigate(`/${empresaSlug}/scanner`, { replace: true });
      }
    } catch {
      setError("No se pudo ingresar.");
    }
    setSending(false);
  };

  const handleKey = e => { if (e.key === "Enter") ingresar(); };

  return (
    <div style={{ ...styles.page, ...(empresaConfig ? brandedPage(empresaConfig) : {}) }}>
      <div style={{ ...styles.card, color: empresaConfig?.colorFuente || "#fff" }}>
        <img src={empresaConfig?.logoUrl || sininLogo} alt={empresaConfig?.nombre || "SININ"} style={styles.companyLogo} />
        <div style={{ ...styles.badge, background: empresaConfig?.colorTicket || styles.badge.background, color: empresaConfig?.colorFuente || SININ_DARK }}>QR</div>
        <h1 style={{ ...styles.title, color: empresaConfig?.colorFuente || "#fff" }}>SCANNER</h1>
        <p style={{ ...styles.sub, color: empresaConfig?.colorFuente || "rgba(255,255,255,.78)" }}>Acceso de scanner · {empresaConfig?.nombre || empresaSlug}</p>

        {error && <div style={styles.error}>{error}</div>}

        <label style={{ ...styles.label, color: empresaConfig?.colorFuente || "#e9ffff" }}>DNI</label>
        <input style={styles.input} value={dni} onChange={e => setDni(e.target.value)} onKeyDown={handleKey} placeholder="12345678" />

        <label style={{ ...styles.label, color: empresaConfig?.colorFuente || "#e9ffff" }}>CONTRASEÑA</label>
        <input
          style={styles.input}
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          onKeyDown={handleKey}
        />

        <button style={{ ...styles.btn, background: empresaConfig?.colorTicket || styles.btn.background, color: empresaConfig?.colorFuente || "#f4fffe" }} onClick={ingresar} disabled={sending}>
          {sending ? "INGRESANDO..." : "INGRESAR AL SCANNER"}
        </button>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background:
      "radial-gradient(circle at 16% 12%, rgba(37,244,223,.55), transparent 30%), radial-gradient(circle at 84% 86%, rgba(70,130,255,.24), transparent 34%), linear-gradient(135deg, #071416 0%, #05080a 58%, #10151a 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 18,
    boxSizing: "border-box",
  },
  card: {
    width: "100%",
    maxWidth: 420,
    background: "rgba(255,255,255,.12)",
    border: "1px solid rgba(255,255,255,.22)",
    borderRadius: 28,
    padding: 24,
    boxShadow: "0 24px 70px rgba(0,0,0,.45)",
    backdropFilter: "blur(18px)",
  },
  logoImg: {
    display: "block",
    width: 210,
    maxWidth: "100%",
    margin: "0 auto 12px",
  },
  companyLogo: { display: "block", width: 190, height: 105, objectFit: "contain", maxWidth: "100%", margin: "0 auto 12px", background: "transparent" },
  badge: {
    width: 68,
    height: 68,
    borderRadius: "50%",
    background: `linear-gradient(135deg, ${SININ_TURQ}, #9bfff4)`,
    color: SININ_DARK,
    display: "grid",
    placeItems: "center",
    fontWeight: 900,
    margin: "0 auto 12px",
    fontSize: 22,
  },
  title: { textAlign: "center", margin: 0, letterSpacing: 2, color: "#fff" },
  sub: { textAlign: "center", color: "rgba(255,255,255,.78)", fontSize: 13, marginBottom: 22 },
  label: { display: "block", fontSize: 12, fontWeight: 900, margin: "12px 0 5px", color: "#e9ffff", letterSpacing: 1 },
  input: {
    width: "100%",
    boxSizing: "border-box",
    border: "1px solid rgba(255,255,255,.34)",
    borderRadius: 18,
    padding: "13px 12px",
    fontSize: 16,
    outline: "none",
    background: "rgba(255,255,255,.9)",
    color: SININ_DARK,
  },
  btn: {
    width: "100%",
    marginTop: 18,
    border: "1px solid rgba(218,255,251,.72)",
    borderRadius: 25,
    background: "linear-gradient(145deg, rgba(207,255,250,.62) 0%, rgba(37,244,223,.34) 46%, rgba(14,145,137,.28) 100%)",
    color: "#f4fffe",
    padding: "14px 16px",
    fontWeight: 900,
    cursor: "pointer",
    letterSpacing: 1,
    textShadow: "0 1px 3px rgba(0,45,42,.72)",
    boxShadow: "inset 0 2px 1px rgba(255,255,255,.62), inset 0 -5px 12px rgba(0,78,73,.22), 0 7px 0 rgba(6,91,86,.7), 0 15px 30px rgba(37,244,223,.3)",
    backdropFilter: "blur(14px) saturate(150%)",
    WebkitBackdropFilter: "blur(14px) saturate(150%)",
  },
  error: {
    background: "#ffe1e1",
    color: "#a30000",
    borderRadius: 14,
    padding: 10,
    marginBottom: 12,
    fontWeight: 700,
    textAlign: "center",
  },
};

const brandedPage = empresa => ({
  background: `radial-gradient(circle at 15% 12%, ${empresa.colorTicket || SININ_TURQ}88, transparent 34%), linear-gradient(145deg, ${empresa.colorFondo || "#1a1a1a"}, ${empresa.colorDark || empresa.colorFondo || SININ_DARK})`,
});
